import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@uplift/hooks';

export type StickyButtonProps = {
  className?: string;
  centerButtons?: boolean;
  hideBorder?: boolean;
};

export const StickyButton: React.FC<StickyButtonProps> = ({ className, children, centerButtons = false, hideBorder = false }) => {
  const { classes, cx } = useStyles({
    centerButtons,
    hideBorder
  });
  const isSmall = useIsMobile('sm');

  return (
    (
      <Box className={cx(isSmall ? classes.mobile : classes.desktop, className)}>
        {children}
      </Box>
    )
  );
};

type StickyStyles = {
  centerButtons: boolean;
  hideBorder: boolean;
};

const useStyles = makeStyles<StickyStyles>({ name: 'StickyButton' })((theme, { hideBorder, centerButtons }) => ({
  desktop: {
    borderTop: hideBorder ? undefined : `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: centerButtons ? 'center' : 'flex-end',
    padding: theme.spacing(2, 1),
    width: '100%',
  },
  mobile: {
    backgroundColor: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.divider}`,
    bottom: 0,
    boxSizing: 'border-box',
    height: '74px',
    left: 0,
    padding: theme.spacing(2),
    position: 'fixed',
    right: 0,
    zIndex: 1000,
    '& button': {
      width: '100%',
    }
  }
}));
